import {Chat, GoalShareIcon, HeartIcon, HeartIconFilled} from '@/assets/icons/icons'
import {useSaveGoalV3} from '@/features/goal/queries/useSaveGoalV3'
import {useUnsaveGoalV3} from '@/features/goal/queries/useUnsaveGoalV3'
import {GoalStatusesE} from '@/features/goal/types'
import {useHandleError} from '@/hooks/useHandleError'
import useRedirectToChatChannel from '@/hooks/useRedirectToChatChannel'
import {IconButton} from '../../../icon-button/IconButton'
import {GoalV3} from '@/features/chat/chat.model'

type GuestStatusSectionProps = {
    goal?: Partial<GoalV3>
    onShareClick?: () => void
    onClose?: () => void
}

export const GuestStatusSection = ({goal, onShareClick, onClose}: GuestStatusSectionProps) => {
    const {
        mutate: saveGoal,
        isError: isSaveGoalError,
        isPending: isLoadingSave,
        error: saveGoalError
    } = useSaveGoalV3(`${goal?.id}`)
    const {
        mutate: unSaveGoal,
        isError: isUnSaveGoalError,
        isPending: isLoadingUnsave,
        error: unSaveGoalError
    } = useUnsaveGoalV3(`${goal?.id}`)
    const redirectToChatChannel = useRedirectToChatChannel({receiverId: parseInt(`${goal?.rookieId}`)})
    const onRedirectChatHandler = () => {
        redirectToChatChannel?.()
        onClose?.()
    }
    const hideAllButtons =
        goal?.status === GoalStatusesE.SUSPENDED ||
        goal?.status === GoalStatusesE.REVIEW ||
        goal?.status === GoalStatusesE.CANCELED
    const hasGuestSupportedGoal = !!goal?.leaderDonationsAmount
    const isActiveGoal = goal?.status === GoalStatusesE.ACTIVE
    const showShareButton =
        (hasGuestSupportedGoal && isActiveGoal) ||
        goal?.status === GoalStatusesE.AWAITING_PROOF ||
        goal?.status === GoalStatusesE.PROOF_PENDING_APPROVAL

    const onSave = () => {
        if (!isLoadingSave && !isLoadingUnsave)
            if (!goal?.isSaved) {
                saveGoal()
            } else {
                unSaveGoal()
            }
    }

    useHandleError({isError: isSaveGoalError || isUnSaveGoalError, error: saveGoalError || unSaveGoalError})

    if (hideAllButtons) return null

    return (
        <>
            {isActiveGoal && (
                <IconButton
                    icon={goal?.isSaved ? <HeartIconFilled height={20} width={20} /> : <HeartIcon />}
                    onClick={onSave}
                />
            )}
            {hasGuestSupportedGoal && <IconButton icon={<Chat />} onClick={onRedirectChatHandler} />}
            {showShareButton && <IconButton icon={<GoalShareIcon />} onClick={onShareClick} />}
        </>
    )
}

// !!!IMPORTANT - this rules only for GUEST side!!!

// 1. If status "active" and guest hasn't supported goal - show only SAVE BUTTON
// 2. If status "active" and guest has supported goal - show SAVE BUTTON, CHAT BUTTON and SHARE BUTTON
// 3. If status "awaiting_proof", "proof_pending_approval", "successful" -  CHAT BUTTON and SHARE BUTTON
// 4. If status "suspended", "review", "canceled" - hide all buttons
